import { formatDateLocal } from './date-time';

export const getFirstAndLastName = (name : string) => {
 if (!name) return ''
 const array = name.split(' ')
 const length = array.length
 let response

 if (length > 1) {
   response = array[0] + ' ' + array[length - 1]
 } else {
   response = array[0]
 }

 return response
}

export function formatarDataParaPTBR(data: string | Date) {
  return formatDateLocal(data, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}
